// store/shipmentNavigationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ShipmentNavPayload = {
  drawerState: 'open' | 'close';
  shipmentId: string | null;
  CoC_ID?: string | null;
};

const initialState: ShipmentNavPayload = {
  drawerState: 'close',
  shipmentId: null,
  CoC_ID: null,
};

const shipmentNavigationSlice = createSlice({
  name: 'shipmentNavigation',
  initialState,
  reducers: {
    setShipmentNav(state, action: PayloadAction<ShipmentNavPayload>) {
      state.drawerState = action.payload.drawerState;
      state.shipmentId = action.payload.shipmentId;
      state.CoC_ID = action.payload.CoC_ID ?? null;
    },
    clearShipmentNav(state) {
      state.drawerState = 'close';
      state.shipmentId = null;
      state.CoC_ID = null;
    },
  },
});

export const { setShipmentNav, clearShipmentNav } =
  shipmentNavigationSlice.actions;

export default shipmentNavigationSlice.reducer;
